// The Optifund Dashboard is scoped to this single site. Its
// website_shared_uid differs per environment (staging/production don't
// share a database), but the site_name is stable across environments, so
// access and the shared_uid to query with are both resolved from it at
// runtime (mirrors src/components/BizDevelopment/LeadsManagement/constants.ts).
export const OPTIFUND_SITE_NAME = "Opti Fund";

export function userHasOptifundSiteAccess(userData: any): boolean {
  const websitePermissions = userData?.data?.website_permissions || [];
  return websitePermissions.some((permission: any) => {
    const details: any = Object.values(permission)[0];
    return details?.site_name === OPTIFUND_SITE_NAME;
  });
}
